import{getHeroCombatKit,selectSignatureCue,type HeroCombatId,type SignatureAttackKind}from'./heroCombatIdentity'
import{nextComboHints,resolveComboSignature}from'./heroComboGrammar'

export type HeroCombatPresentation={
  heroId:HeroCombatId
  stance:string
  rhythm:string
  attack:SignatureAttackKind|null
  skillName:string|null
  animationVariant:string|null
  trail:string|null
  impact:string|null
  comboName:string|null
  nextHints:readonly SignatureAttackKind[]
}

export function appendAttackHistory(history:readonly SignatureAttackKind[],attack:SignatureAttackKind,limit=8):SignatureAttackKind[]{
  if(!Number.isSafeInteger(limit)||limit<1||limit>32)throw new Error(`Invalid attack history limit: ${limit}`)
  return[...history,attack].slice(-limit)
}

export function deriveHeroCombatPresentation(heroId:HeroCombatId,lastAttack:SignatureAttackKind|null,comboCount:number,history:readonly SignatureAttackKind[]):HeroCombatPresentation{
  if(!Number.isSafeInteger(comboCount)||comboCount<0)throw new Error(`Invalid combo count: ${comboCount}`)
  const kit=getHeroCombatKit(heroId)
  const combo=resolveComboSignature(heroId,history)
  const nextHints=nextComboHints(heroId,history)
  if(lastAttack===null)return{heroId,stance:kit.stance,rhythm:kit.rhythm,attack:null,skillName:null,animationVariant:null,trail:null,impact:null,comboName:combo?.name??null,nextHints}
  const cue=selectSignatureCue(heroId,lastAttack,comboCount)
  return{heroId,stance:kit.stance,rhythm:kit.rhythm,attack:lastAttack,skillName:cue.skillName,animationVariant:cue.animationVariant,trail:cue.trail,impact:cue.impact,comboName:combo?.name??null,nextHints}
}
